var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7H17M13 1V3M5 1V3M4.2002 3H13.8002C14.9203 3 15.48 3 15.9078 3.21799C16.2841 3.40973 16.5905 3.71572 16.7822 4.09204C17.0002 4.51986 17 5.07985 17 6.19995V13.8C17 14.9201 17.0002 15.4802 16.7822 15.908C16.5905 16.2844 16.2841 16.5902 15.9078 16.782C15.48 17 14.9203 17 13.8002 17H4.2002C3.08009 17 2.51962 17 2.0918 16.782C1.71547 16.5902 1.40973 16.2844 1.21799 15.908C1 15.4802 1 14.9201 1 13.8V6.19995C1 5.07985 1 4.51986 1.21799 4.09204C1.40973 3.71572 1.71547 3.40973 2.0918 3.21799C2.51962 3 3.08009 3 4.2002 3Z",
    stroke: "#888896",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b0d445096d08214f3d20464e265f68d3.svg";
export { ForwardRef as ReactComponent };